import React from 'react';
import AdminLayout from '../../../components/Admin/Layout/AdminLayout';
import SettingsHub from '../../../components/Admin/Settings/SettingsHub';

/**
 * Settings Hub Page
 *
 * Main settings page that shows all available settings categories as cards.
 * Users click on a card to navigate to that specific settings section.
 */
export default function SettingsHubPage() {
  return (
    <AdminLayout>
      <SettingsHub />
    </AdminLayout>
  );
}
